import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import { makeStyles, Button } from 'design-system';
import Sample from '../instruction/typeComponents/sample';
import Markdown from '@scale/frontend-lib/markdown';
// eslint-disable-next-line restrict-imports/restrict-imports
import Popper from '@material-ui/core/Popper';
import { useProjectInstructionContext } from 'react-scale/components/scalers/instruction/projectInstructionContext';
import { Event, logEvent } from '@scale/frontend-lib/events';

const TaxonomyInstructionPopper = ({
  title,
  popRef,
  show,
}: {
  title?: string;
  show: boolean;
  popRef: React.RefObject<HTMLElement>;
}) => {
  const classes = useStyles();
  const [arrowRef, setArrowRef] = useState<HTMLSpanElement | null>(null);
  const { projectInstruction, enableSidePanel, projectId, showingInstructionsFn, setSelectedPath } =
    useProjectInstructionContext();

  const componentInstruction = useMemo(() => {
    const components = _.get(projectInstruction, ['instruction', 'components'], []);
    return components?.find((comp: $FIXME) => comp.title === title);
  }, [projectInstruction, title]);

  if (!componentInstruction) {
    return null;
  }

  const { _id, type, description } = componentInstruction;
  const firstSample = _.get(componentInstruction, ['examples', 0, 'samples', 0]);
  const handleClick = async () => {
    if (enableSidePanel) {
      showingInstructionsFn(true);
      setSelectedPath([type, _id]);
    } else {
      const instructionPageUrl =
        window.location.origin + `/instruction/${projectId}?type=${type}&componentId=${_id}`;
      window.open(instructionPageUrl, '_blank');
    }
    const data = {
      isNewInstruction: true,
      isOnboardingFlow: null,
      isDuringTasking: true,
      contextualTrigger: true,
      enableSidePanel,
      startTime: new Date().getTime(),
      closeTime: null,
    };

    await logEvent(Event.InstructionRenderRecord, data);
  };

  return (
    <Popper
      open={show}
      anchorEl={popRef?.current}
      modifiers={{
        preventOverflow: {
          enabled: true,
          boundariesElement: 'window',
        },
        arrow: {
          enabled: true,
          element: arrowRef,
        },
      }}
      placement="left"
      className={classes.popper}
    >
      <span className={classes.arrow} ref={setArrowRef} />
      <div className={classes.content}>
        <strong>
          <big>{_.startCase(title)} instruction</big>
        </strong>
        <div
          style={{
            maxHeight: 250,
            overflow: 'scroll',
          }}
          dangerouslySetInnerHTML={{
            __html: Markdown.render(description || ''),
          }}
        />
        {firstSample && <Sample sample={firstSample} index={0} key={0} fullWidth />}
      </div>
      <div className={classes.btnWrapper}>
        <Button type="primary" onClick={handleClick}>
          See full instruction
        </Button>
      </div>
    </Popper>
  );
};

const useStyles = makeStyles({
  popper: {
    zIndex: 1000,
    background: 'black',
    width: 300,
    borderRadius: 5,
    color: 'white',
    padding: 10,
  },

  arrow: {
    position: 'absolute',
    width: '1em',
    height: '1em',
    boxSizing: 'border-box',
    right: 0,
    '&::after': {
      content: '""',
      display: 'block',
      width: '0.9em',
      height: '0.9em',
      background: 'black',
      transform: 'translateX(50%) rotate(45deg)',
    },
  },

  content: {
    '& p': {
      lineHeight: 1,
    },
  },

  btnWrapper: {
    marginTop: 15,
    display: 'flex',
    '& > button': {
      marginLeft: 'auto',
    },
  },
});
export default TaxonomyInstructionPopper;
